import { ChainFullIds } from "@umami/chains";
import { useDynamicModalContext } from "@umami/components";
import { useCurrentAccount, useGetSaplingAccount, useIsSaplingEnabled } from "@umami/state";

import { ActivateSaplingModal } from "../Sappling/ActivateSaplingModal";
import { PrepareTransactionPage as SendShieldedFormPage } from "../Sappling/SendShieldedFlow";
import { ShieldedBalance } from "../Sappling/ShieldedBalance";

export const ShieldedBalanceItem = () => {
  const { openWith } = useDynamicModalContext();
  const currentAccount = useCurrentAccount();
  const saplingAccount = useGetSaplingAccount(currentAccount?.address.pkh ?? "");
  const isSaplingEnabled = useIsSaplingEnabled()();

  if (currentAccount?.type === "ledger" || !isSaplingEnabled) {
    return null;
  }

  const handleShieldedBalanceClick = () => {
    if (!saplingAccount) {
      return openWith(<ActivateSaplingModal />);
    }

    return openWith(<SendShieldedFormPage chainId={ChainFullIds.TEZOS} />);
  };

  return <ShieldedBalance padding="12px" onClick={handleShieldedBalanceClick} />;
};
